import React, { Suspense, useEffect, useRef, useState } from "react";
import { Heading, Img, Button, Text } from "../../components";
import axios from "axios";
import { API_DOMAIN_IMG, API_DOMAIN } from "config";


export default function FilterBarNotifications({ onChange, unreadNotifications=[], readNotifications=[] }) {
  const seenOptions = [
    { id: "yes", name: "כן" },
    { id: "no", name: "טרם" },
  ];
  const [selectedSeen, setSelectedSeen] = useState([]);

  const carTypeOptions = ["פרטי", "מסחרי"];
  const accidentTypeOptions = ["קלה", "בינונית", "קשה"];

  const [priceMin, setPriceMin] = useState(1000);
  const [priceMax, setPriceMax] = useState(1000000);
  const [carTypes, setCarTypes] = useState([]);

  const [manufacturerOptions, setManufacturerOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);

  const [selectedManufacturers, setSelectedManufacturers] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);
  const [models, setModels] = useState([]);
  const [accidentTypes, setAccidentTypes] = useState([]);
  const [minPriceLimit, setMinPriceLimit] = useState(1000);
  const [maxPriceLimit, setMaxPriceLimit] = useState(1000000);
  const [auction, setAuction] = useState(false);
  const [rehabilitation, setRehabilitation] = useState(false);
  const [dismantle, setDismantle] = useState(false);
  const [selectedSaleTypes, setSelectedSaleTypes] = useState([]);

  // ✅ FIX (מינימום שינוי): ניהול פתיחה/סגירה של הפילטר במובייל בתוך FilterBar + onClick לכפתור
  const [drawerOpen, setDrawerOpen] = useState(false);
  const barRef = useRef(null);

  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  const toggleDrawer = (e) => {
    if (!isMobile()) return;
    e.stopPropagation();
    setDrawerOpen((v) => !v);
  };

  useEffect(() => {
    if (!isMobile()) return;

    const closeOnOutside = (e) => {
      if (!barRef.current) return;
      if (!barRef.current.contains(e.target)) setDrawerOpen(false);
    };

    const handleResize = () => {
      if (!isMobile()) setDrawerOpen(false);
    };

    document.addEventListener("click", closeOnOutside);
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("click", closeOnOutside);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const [mfs, mdl, yrs] = await Promise.all([
          axios.get(`${API_DOMAIN}/car/getAllManufucters`),
          axios.get(`${API_DOMAIN}/car/getAllModels`),
          axios.get(`${API_DOMAIN}/car/getAllYears`),
        ]);

        setManufacturerOptions(mfs.data.map((x) => x.name));
        setModelOptions(mdl.data.map((x) => x.name));
        setYearOptions(yrs.data.map(String));
      } catch (err) {
        console.error("שגיאה בשליפת נתוני סינון:", err);
      }
    })();
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      onChange?.({
        priceMin: priceMin !== minPriceLimit ? priceMin : null,
        priceMax: priceMax !== maxPriceLimit ? priceMax : null,
        manufacturers: selectedManufacturers,
        models: selectedModels,
        years: selectedYears,
        carTypes,
        accidentTypes,
        saleTypes: selectedSaleTypes.map(Number),
        // when empty -> don't filter; parent treats missing/empty as show all
        seen: selectedSeen.length ? selectedSeen : undefined,
      });
    }, 250);

    return () => clearTimeout(t);
  }, [
    priceMin,
    priceMax,
    selectedManufacturers,
    selectedModels,
    selectedYears,
    carTypes,
    accidentTypes,
    selectedSaleTypes,
    minPriceLimit,
    maxPriceLimit,
    selectedSeen,
    onChange,
  ]);

  return (
    <div
    dir="rtl"
      ref={barRef}
      className={`filter-bar w-full overflow-visible py-2 ${drawerOpen ? "open" : ""}`}
      
    >
      <div
className="notif-bar flex rounded-full border border-gray-200 bg-white px-2 py-2 w-full"
        style={{ paddingRight: "0.5rem" }}
      >


       <div className="flex gap-2 text-xs !font-heebo count-notif items-center">
  <span className="order-to text-[14px]">סה"כ התראות:</span>

  <span
    className="px-3 py-1 rounded-[5px] text-[12px] font-semibold leading-none"
    style={{ backgroundColor: "#E9E9E9", color: "#303131" }}
  >
    {unreadNotifications.length + readNotifications.length}
  </span>

  <span className="order- text-[14px]">נצפו:</span>

  <span
    className="px-3 py-1 rounded-[5px] text-[12px] font-semibold leading-none"
    style={{ backgroundColor: "#EDFFD8", color: "#77AC3B" }}
  >
    {readNotifications.length}
  </span>

  <span className="order-to text-[14px]">טרם נצפו:</span>

  <span
    className="px-3 py-1 rounded-[5px] text-[12px] font-semibold leading-none"
    style={{ backgroundColor: "#FFE9E9", color: "#D61F1F" }}
  >
    {unreadNotifications.length}
  </span>
</div>
 

        {/* Checkboxes */}
        <div className="flex items-center gap-2 border-l border-gray-200 px-4 py-1 min-w-[200px]
                max-md:order-2">    
                      <span className="order-to text-[14px] font-semibold">נצפה:</span>

          {seenOptions.map(({ id, name }) => (
            <label key={id} className="checkbox-item">
              <input
                type="checkbox"
                checked={selectedSeen.includes(id)}
                onChange={() =>
                  setSelectedSeen((prev) =>
                    prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
                  )
                }
              />
              <span className="custom-checkbox" />
              {name}
            </label>
          ))}

        </div>
        <Button className="hide-desktop" type="button" onClick={toggleDrawer}>
          <Img src="images/filter-icon.svg" />
        </Button>

<Button className="hide-mobile" type="button" onClick={toggleDrawer}>
  <div className="bg-[#CE0000] p-[17px] rounded-[50px]">
    <Img src="images/white-filter.svg" />
  </div>
</Button>
        
      </div>
    </div>
  );
}
